export enum affidavitStates {
    presentada = 'presentada',
    sinPresentar = 'sinPresentar',
    inactiva = 'inactiva',
    rectificada = 'rectificada',
}
